import styled from '@emotion/styled'
import { colors, typo } from '@mathflat/common/style'
import { observer } from 'mobx-react'
import modalService from 'src/service/modal.service'

import _Button from '@/component/atoms/Button/_Button/_Button'
import { _OldButton } from '@/component/atoms/Button/_OldButton'
import { outerLink } from '@/constant/outerLink'
import commonRepo from '@/repository/common.repo'
import { openLink } from '@/utils/common'

const NoAgent = () => {
  return (
    <Wrap>
      <p>연결된 프린터가 없습니다.</p>
      <p>프린터를 연결하기 위해서 {commonRepo.appKorName} PC용앱을 다운 받은 후 로그인 해주세요.</p>
      <div>
        <_OldButton
          width={186}
          height={40}
          theme="default"
          onClick={() => {
            if (commonRepo.isSchoolflat) {
              openLink(outerLink.스쿨플랫_프린트연결이_끊겼을_경우_링크)
            } else {
              openLink('https://freewheelin.notion.site/fccdfd78670f49d6a20185afdf56042e')
            }
            modalService.closeModal()
          }}
        >
          로그인해도 연결이 안 될 때
        </_OldButton>
        <_Button
          minWidth={160}
          size="m"
          theme="primary"
          onClick={() => {
            if (commonRepo.isSchoolflat) {
              openLink(outerLink.스쿨플랫_인쇄하기_가이드_링크)
            } else {
              openLink(outerLink.매쓰플랫_인쇄하기_가이드_링크)
            }
            window.open(`https://${commonRepo.host}/p.exe`)
            modalService.closeModal()
          }}
        >
          PC용앱 설치파일 다운로드
        </_Button>
      </div>
    </Wrap>
  )
}

export default observer(NoAgent)

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 0;
  width: 494px;
  p {
    color: ${colors.gray.$900};
    ${typo.body02};
  }
  > div {
    display: flex;
    margin-top: 24px;
    > button:first-of-type {
      margin-right: 8px;
    }
  }
`
